var React = require('react');

function FooterLine2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"vectorEffect":"non-scaling-stroke","d":"M-918.1-1094.583c6.173-.236,588.88-10.035,1073.813-10.035s785.577,11.638,865.918,10.035,82.228-2.944,142.225-4.8c47.6-1.471,101.971-5.237,159.852-5.237,65.818,0,52.73,2.3,159.508,5.237s146.969,4.581,267.6,6.521c63.607,1.023,50.516-6.521,126.516-6.521s61.81,6.521,177.484,6.521c110,0,179.021-8.578,216.36.986,41.905,5.368,97.545-.131,189.3-.986,74.608-.7,100.934,7.676,240.969,5.426,53.493-.859,112.693-3.167,165.449-5.693,23.63-1.131,189.234-9.589,417.228-9.728,240.727-.146,550.308,9.063,832.844,10.981,415.432,2.82,773.422-1.253,773.422-1.253","transform":"translate(919.142 1105.617)","fill":"none","stroke":"#e88661","strokeLinecap":"round","strokeWidth":"2"}));
}

FooterLine2.defaultProps = {"width":"5810.533","height":"19.493","viewBox":"0 0 5810.533 19.493"};

module.exports = FooterLine2;

FooterLine2.default = FooterLine2;
